export default "/images/vanilla-bear-1.jpg";